import { render } from "./InfoFatturazione.vue?vue&type=template&id=54fa6a2c&scoped=true"
import script from "./InfoFatturazione.vue?vue&type=script&lang=js"
export * from "./InfoFatturazione.vue?vue&type=script&lang=js"

import "./InfoFatturazione.vue?vue&type=style&index=0&id=54fa6a2c&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fa6a2c"]])

export default __exports__